export enum BasketballTwoPointShotMissedAttribute {
  JumpShot = 655,
  Layup = 656,
  Dunk = 657,
  Hook = 658,
}
